<template>
    <div class="home">
      <div class="container">
        <div class="columns is-centered">
          <div class="column">
            <ValidationObserver v-slot="{ errors }" tag="div">
            <input-form
              ref="form"
              :errors="errors"
              name="ProjectTeam"
              @submit.prevent="onFileUpload"
            >
                <div class="content">
                <h1>Development Questions</h1>
                <div class="columns">
                    <div class="column">
                        <vee-dropdown
                            v-model="FullSummaryApplication.SiteControl"
                            :options="yesNo"
                            name="text-site-control"
                            placeholder="Do you have site control?"
                            required
                            rules="required"
                            type="text"
                        />
                    </div>
                    <div class="column">
                        <vee-dropdown
                            v-model="FullSummaryApplication.ZoningSecured"
                            :options="yesNo"
                            name="text-zoning-secured"
                            placeholder="Has zoning been secured?"
                            required
                            rules="required"
                            type="text"
                        />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <vee-dropdown
                            v-model="FullSummaryApplication.CommunityMeeting"
                            :options="yesNo"
                            name="text-community-meeting"
                            placeholder="Has a community meeting been held?"
                            required
                            rules="required"
                            type="text"
                        />
                    </div>
                    <div class="column">
                        <vee-dropdown
                            v-model="FullSummaryApplication.EstimatedConstructionTimeline"
                            :options="constructionTimeline"
                            name="text-estimated-construction-timeline"
                            placeholder="What is the estimated construction timeline (in months)?"
                            required
                            rules="required"
                            type="text"
                        />
                    </div>
                </div>
                <div class="columns">
                <div class="column">
                    <h4>Project Excel Workbook <i style="color: #cc3000;">(required)</i></h4>
                    <file-upload
                        ref="upload"
                        v-model="FullSummaryApplication.ProjectWorkbook"
                        input-id="file-project-workbook"
                        extensions="gif,jpg,jpeg,png,webp,pdf"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        label="File"
                        @input-filter="inputFilter"
                        >
                        <button class="button is-primary" style="margin-bottom: 1%;">
                        <i class="fa fa-plus"></i>
                        &nbsp; Select File to Upload
                        </button>
                </file-upload>
                <li v-for="file in FullSummaryApplication.ProjectWorkbook" :key="file.id">
                    <span>{{ file.name }} - </span>
                    <span
                        v-if="file.error"
                        class="is-love-park-red"
                    >
                        Something went wrong - {{ file.errorMessage }}
                    </span>

                    <span
                        v-else-if="file.success"
                        class="is-phanatic-green"
                    >
                        Upload Successful.
                    </span>
                    <span
                        v-else-if="file.uploading"
                        class="is-flyers-orange"
                    >
                        Uploading Document...</span>
                    </li>
            </div>
            <div class="column">
                    <h4>Proposal Narrative and Supporting Documents <i style="color: #cc3000;">(required)</i></h4>
                    <file-upload
                        ref="upload"
                        v-model="FullSummaryApplication.ProposalDocuments"
                        input-id="file-proposal-documents"
                        extensions="gif,jpg,jpeg,png,webp,pdf"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        label="File"
                        @input-filter="inputFilter"
                        >
                        <button class="button is-primary" style="margin-bottom: 1%;">
                        <i class="fa fa-plus"></i>
                        &nbsp; Select File to Upload
                        </button>
                </file-upload>
                <li v-for="file in FullSummaryApplication.ProposalDocuments" :key="file.id">
                    <span>{{ file.name }} - </span>
                    <span
                        v-if="file.error"
                        class="is-love-park-red"
                    >
                        Something went wrong - {{ file.errorMessage }}
                    </span>

                    <span
                        v-else-if="file.success"
                        class="is-phanatic-green"
                    >
                        Upload Successful.
                    </span>
                    <span
                        v-else-if="file.uploading"
                        class="is-flyers-orange"
                    >
                        Uploading Document...</span>
                    </li>
            </div>
            <!-- <div class="column">
                    <h4>Project List Template <i style="color: #cc3000;">(required)</i></h4>
                    <file-upload
                        ref="upload"
                        v-model="FullSummaryApplication.EOPForm"
                        input-id="file-eop-form"
                        extensions="gif,jpg,jpeg,png,webp,pdf"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        label="File"
                        @input-filter="inputFilter"
                        >
                        <button class="button is-primary" style="margin-bottom: 1%;">
                        <i class="fa fa-plus"></i>
                        &nbsp; Select File to Upload
                        </button>
                </file-upload>
                <li v-for="file in FullSummaryApplication.EOPForm" :key="file.id">
                    <span>{{ file.name }} - </span>
                    <span
                        v-if="file.error"
                        class="is-love-park-red"
                    >
                        Something went wrong - {{ file.errorMessage }}
                    </span>

                    <span
                        v-else-if="file.success"
                        class="is-phanatic-green"
                    >
                        Upload Successful.
                    </span>
                    <span
                        v-else-if="file.uploading"
                        class="is-flyers-orange"
                    >
                        Uploading Document...</span>
                    </li>
            </div> -->
            </div>
            <!-- <div class="columns"> -->
                
            <!-- <div class="column">
                    <h4>Philadelphia Tax Status Certificate <i style="color: #cc3000;">(required)</i></h4>
                    <file-upload
                        ref="upload"
                        v-model="FullSummaryApplication.TaxCertificate"
                        input-id="file-tax-status-certificate"
                        extensions="gif,jpg,jpeg,png,webp,pdf"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        label="File"
                        @input-filter="inputFilter"
                        >
                        <button class="button is-primary" style="margin-bottom: 1%;">
                        <i class="fa fa-plus"></i>
                        &nbsp; Select File to Upload
                        </button>
                </file-upload>
                <li v-for="file in FullSummaryApplication.TaxCertificate" :key="file.id">
                    <span>{{ file.name }} - </span>
                    <span
                        v-if="file.error"
                        class="is-love-park-red"
                    >
                        Something went wrong - {{ file.errorMessage }}
                    </span>

                    <span
                        v-else-if="file.success"
                        class="is-phanatic-green"
                    >
                        Upload Successful.
                    </span>
                    <span
                        v-else-if="file.uploading"
                        class="is-flyers-orange"
                    >
                        Uploading Document...</span>
                    </li>
            </div> -->
            <!-- </div> -->
            <!-- <div class="columns">
              <div class="column">
                    <h4>Campaign Disclosure Form <i style="color: #cc3000;">(required)</i></h4>
                    <file-upload
                        ref="upload"
                        v-model="FullSummaryApplication.CampaignDisclosure"
                        input-id="file-campaign-disclosure"
                        extensions="gif,jpg,jpeg,png,webp,pdf"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        label="File"
                        @input-filter="inputFilter"
                        >
                        <button class="button is-primary" style="margin-bottom: 1%;">
                        <i class="fa fa-plus"></i>
                        &nbsp; Select File to Upload
                        </button>
                </file-upload>
                <li v-for="file in FullSummaryApplication.CampaignDisclosure" :key="file.id">
                    <span>{{ file.name }} - </span>
                    <span
                        v-if="file.error"
                        class="is-love-park-red"
                    >
                        Something went wrong - {{ file.errorMessage }}
                    </span>

                    <span
                        v-else-if="file.success"
                        class="is-phanatic-green"
                    >
                        Upload Successful.
                    </span>
                    <span
                        v-else-if="file.uploading"
                        class="is-flyers-orange"
                    >
                        Uploading Document...</span>
                    </li>
            </div>
            </div> -->
            <div class="columns">
                  <div class="column" style="text-align: left;">
                      <button
                      type="button"
                      class="button is-primary"
                      @click="prevPage"
                      >
                      Back
                      </button>
                  </div>
                  <div class="column" style="text-align: right;">
                      <button
                      type="button"
                      class="button is-primary"
                      :disabled="FullSummaryApplication.ProjectWorkbook.length < 1 || FullSummaryApplication.ProposalDocuments.length < 1"
                      @click="nextPage"
                      >
                      Next
                      </button>
                  </div>
              </div>
                </div>
            </input-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import { getPropertyValueOrDefault } from "@/utilities/functions.js";
// import buildPropertyInfoObject from "@/utilities/get-property-info-object.js";
// import axios from "axios";
import options from "@/utilities/options";
import FileUpload from "vue-upload-component";

export default {
  name: 'DevelopmentPage',
  components: { FileUpload },
  mixins: [options],
  data() {
    return {
      FullSummaryApplication: null,
    };
  },
  async beforeMount(){
    window.scrollTo(0, 0);
    this.FullSummaryApplication = await this.$vlf.getItem('fullSummaryApplication');
  },
  methods: {
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?|exe?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    async nextPage(){
        const isInputValid = await this.$refs.form.$parent.validate();
        if (isInputValid) {
            this.$vlf.removeItem('fullSummaryApplication');
            await this.$vlf.setItem('fullSummaryApplication', this.FullSummaryApplication);
            
            this.$router.push({
                name: "RFPConfirmationPage",
            });
        }
    },
    async prevPage(){
        const isInputValid = await this.$refs.form.$parent.validate();
        if (isInputValid) {
            this.$vlf.removeItem('fullSummaryApplication');
            await this.$vlf.setItem('fullSummaryApplication', this.FullSummaryApplication);
            
            this.$router.push({
                name: "UnitDetails",
            });
        }
    },
  }
};
</script>